import { Injectable, signal, WritableSignal } from '@angular/core';

export enum EDropListViewMode {
  None = 'none',
  UnassignedList = 'unassignedList',
  Category = 'category',
}

@Injectable({
  providedIn: 'root',
})
export class TicketDragAndDropSupportService {
  public ticketIsBeingDragged: WritableSignal<boolean> = signal(false);

  public readonly currentDropListViewMode: WritableSignal<EDropListViewMode> =
    signal(EDropListViewMode.None);
}
